import { salaryWeights } from './../../../configs/salary-weight.config';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { WeightCounterComponent } from '../weight-counter/weight-counter.component';
import { AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SeasonFormGroup } from '../../../models/season-form.model';
import { SeasonBaseFormComponent } from '../season-base-form/season-base-form.component';
import { SeasonBaseFormHeaderComponent } from '../season-base-form/season-base-form-header/season-base-form-header.component';

@Component({
    selector: 'app-salary-weight',
    templateUrl: './salary-weight.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [WeightCounterComponent, ReactiveFormsModule, TranslateModule, SeasonBaseFormHeaderComponent]
})
export class SalaryWeightComponent extends SeasonBaseFormComponent {
    public readonly salaryWeight = input<SeasonFormGroup['salary']>();

    protected salaryWeights = salaryWeights;

    protected getFormControl(): AbstractControl {
        return this.salaryWeight();
    }
}
